import { useMemo, useState } from 'react';

import { buildColorIndex } from './chartPalette';
import type { UserSeries } from '@/helpers/leagues/standingsSeries';
import type { gameResult } from '@/models/gameUpdate';
import type { LeagueHistoryColumn } from '@/models/leagueHistory';
import { useChartPlayback } from './useChartPlayback';

export interface StandingsChartPanelData {
  series: UserSeries[];
  maxMatchday: number;
  columns: LeagueHistoryColumn[];
  currentUid?: string;
  gameResults: gameResult[];
}

export function useStandingsChartPanel(props: StandingsChartPanelData) {
  const [hoveredUid, setHoveredUid] = useState<string | null>(null);
  const [selectedUids, setSelectedUids] = useState<Set<string>>(() => new Set());
  const [selectedMatchday, setSelectedMatchday] = useState<number>(props.maxMatchday);

  const playback = useChartPlayback(props.maxMatchday);

  const colorIndex = useMemo(() => buildColorIndex(props.series.map((s) => s.uid)), [props.series]);

  const toggleSelected = (uid: string) =>
    setSelectedUids((prev) => {
      const next = new Set(prev);
      if (next.has(uid)) next.delete(uid);
      else next.add(uid);
      return next;
    });

  const clearSelection = () => setSelectedUids(new Set());

  return {
    hoveredUid,
    setHoveredUid,
    selectedUids,
    selectedMatchday,
    setSelectedMatchday,
    playback,
    colorIndex,
    toggleSelected,
    clearSelection,
  };
}
